
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("5WSiB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $436e088c5d0f54a3$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $4rBM8 = parcelRequire("4rBM8");

var $7Y1tj = parcelRequire("7Y1tj");

var $6eNI5 = parcelRequire("6eNI5");

var $fALlm = parcelRequire("fALlm");

var $4HGiq = parcelRequire("4HGiq");

var $7452z = parcelRequire("7452z");

var $h6aRF = parcelRequire("h6aRF");

var $2kfyN = parcelRequire("2kfyN");

var $NAfW5 = parcelRequire("NAfW5");

var $a5qoX = parcelRequire("a5qoX");

var $1UkGo = parcelRequire("1UkGo");

const $436e088c5d0f54a3$var$BasePage = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("b8EMT"))));
const $436e088c5d0f54a3$var$LoginPage = ()=>{
    var _state_login;
    (0, $7Y1tj.useLoginPageViewed)();
    const shouldOrchestrate = (0, $h6aRF.useShouldOrchestrate)();
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { errorCode: errorCode } = (0, $NAfW5.useSearchParamCodes)();
    const error = (state === null || state === void 0 ? void 0 : (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.error) || errorCode;
    const recaptchaType = (error === null || error === void 0 ? void 0 : error.code) === 'captchaScoreTooLow' ? 'checkbox' : 'score';
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6eNI5.LoginTooManyAttemptsRecaptchaContextProvider), {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fALlm.LoginRecoveryOptionsContextProvider), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4HGiq.LoginGoogleOneTapRenderBoundary), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7452z.MarketingConsentContextProvider), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $a5qoX.RecaptchaContextProvider), {
                        pageId: (0, $1UkGo.loginPageId),
                        action: "checkUsername",
                        type: recaptchaType,
                        children: shouldOrchestrate ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2kfyN.default), {}) : /*#__PURE__*/ (0, $4ZSso.jsx)($436e088c5d0f54a3$var$BasePage, {})
                    })
                })
            })
        })
    });
};
var $436e088c5d0f54a3$export$2e2bcd8739ae039 = $436e088c5d0f54a3$var$LoginPage;

});
parcelRegister("7Y1tj", function(module, exports) {

$parcel$export(module.exports, "useLoginPageViewed", function () { return $399b66e3175a5391$export$6d3326ed5d8fb40e; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6d87w = parcelRequire("6d87w");

var $1V2cH = parcelRequire("1V2cH");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");
const $399b66e3175a5391$export$6d3326ed5d8fb40e = ()=>{
    const location = (0, $6d87w.useLocation)();
    const queryParams = new URLSearchParams(location.search);
    const appendReasonViewingScreen = (0, $NAfW5.useAppendReasonViewingScreen)();
    (0, $1V2cH.usePageViewedEvent)((0, $1UkGo.loginPageId), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $1V2cH.appendReferer)(appendReasonViewingScreen({}))), {
        noAccess: !!queryParams.get('tenant')
    }));
    (0, $1V2cH.useOperationalEvent)({
        page: (0, $1UkGo.loginPageId),
        action: 'loadLoginPageSuccessful',
        subject: 'sli'
    });
};

});

parcelRegister("4HGiq", function(module, exports) {

$parcel$export(module.exports, "LoginGoogleOneTapRenderBoundary", function () { return $2485820e2931b4d6$export$bc9e03527d642019; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9OWP7 = parcelRequire("9OWP7");

var $1rFqe = parcelRequire("1rFqe");

var $4rBM8 = parcelRequire("4rBM8");

var $1UkGo = parcelRequire("1UkGo");

var $fALlm = parcelRequire("fALlm");

var $h6Rwg = parcelRequire("h6Rwg");

var $2UbF1 = parcelRequire("2UbF1");

var $3H79M = parcelRequire("3H79M");

var $1HVXA = parcelRequire("1HVXA");
const $2485820e2931b4d6$export$bc9e03527d642019 = ({ children: children })=>{
    const dynamicConfigs = (0, $2UbF1.useDynamicConfigs)();
    const { loginRecoveryOptions: loginRecoveryOptions } = (0, $fALlm.useLoginRecoveryOptionsContext)();
    const { isGoogleOneTapDismissed: isGoogleOneTapDismissed } = (0, $h6Rwg.useSocialLogin)();
    const { state: state, isLoading: isPageStateLoading, error: pageStateError } = (0, $4rBM8.useLoginState)();
    if (isPageStateLoading) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {
        label: "Login page loading"
    });
    else if (!state || pageStateError) throw new Error(`Page state loading unsuccessful. \nPage state error: ${pageStateError}`);
    const { googleAuthClientId: googleAuthClientId } = state.appConfig;
    const { hashedCsrfToken: hashedCsrfToken } = state;
    const disableOneTap = isGoogleOneTapDismissed || (0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).GOOGLE_ONE_TAP_KILL_SWITCH);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1rFqe.default), {
        csrfToken: hashedCsrfToken !== null && hashedCsrfToken !== void 0 ? hashedCsrfToken : 'token-should-be-loaded',
        googleAuthClientId: googleAuthClientId,
        source: (0, $1UkGo.loginPageId),
        enabled: !disableOneTap,
        recoveryOptions: loginRecoveryOptions,
        children: children
    });
};

});

parcelRegister("2kfyN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $751e2a661bc986f3$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $h6aRF = parcelRequire("h6aRF");

var $4Nxm2 = parcelRequire("4Nxm2");

var $6xwQE = parcelRequire("6xwQE");

var $h6Rwg = parcelRequire("h6Rwg");

var $NAfW5 = parcelRequire("NAfW5");

var $cZAbO = parcelRequire("cZAbO");

var $cs6gC = parcelRequire("cs6gC");

var $7D2jm = parcelRequire("7D2jm");

var $dBW46 = parcelRequire("dBW46");

var $6OnpU = parcelRequire("6OnpU");

const $751e2a661bc986f3$var$baseLoginPage = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("b8EMT"))));
const $751e2a661bc986f3$var$requiredComponents = [
    (0, $4Nxm2.useLogin).name,
    (0, $6xwQE.useLoginSubmission).name,
    (0, $h6Rwg.useSocialLogin).name,
    (0, $NAfW5.useEmailFromSearchParams).name,
    (0, $cZAbO.LoginRecaptcha).name,
    (0, $cs6gC.LoginMarketingConsent).name,
    (0, $6OnpU.ResetPasswordLink).name
];
const $751e2a661bc986f3$var$OrchestratedLoginPage = ()=>{
    const { shouldShowRememberedAccounts: shouldShowRememberedAccounts } = (0, $4Nxm2.useLogin)();
    if (shouldShowRememberedAccounts) // cobranding is not currently available for this page. the base page should NOT be modified for cobranding
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7D2jm.default), {});
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h6aRF.PageOrchestrator), {
        fallback: $751e2a661bc986f3$var$baseLoginPage,
        pages: (0, $dBW46.pages),
        requiredComponents: $751e2a661bc986f3$var$requiredComponents
    });
};
var $751e2a661bc986f3$export$2e2bcd8739ae039 = $751e2a661bc986f3$var$OrchestratedLoginPage;

});
parcelRegister("dBW46", function(module, exports) {

$parcel$export(module.exports, "pages", function () { return $301af16466d55e42$export$da3bc2f57520e3c3; });

var $91i6m = parcelRequire("91i6m");

var $6IwzG = parcelRequire("6IwzG");









const $301af16466d55e42$export$da3bc2f57520e3c3 = [
    {
        experience: (0, $6IwzG.AdvancedCobranding).DEMO,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("0xO0G"))),
        owner: 'iignatov2@atlassian.com',
        slackChannel: 'id-kirby',
        monitoringUrls: [
            'prod: https://pollinator.prod.atl-paas.net/checks/ae69f832-ceac-472c-9cb3-916cdc50e48f',
            'stg: https://pollinator.prod.atl-paas.net/checks/efa267f0-f1e2-456f-8ef8-c34a3c32b350',
            'ddev: https://pollinator.prod.atl-paas.net/checks/6e9db949-2d59-40dc-861b-5381070f2be7'
        ]
    },
    {
        experience: (0, $6IwzG.AdvancedCobranding).PRT_DEMO,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("jb1yl"))),
        owner: 'jbell2@atlassian.com',
        slackChannel: 'id-kirby',
        monitoringUrls: [
            'KIRBY-9547: Add monitoring URLs for PRT demo'
        ]
    },
    {
        experience: (0, $6IwzG.AdvancedCobranding).CONFLUENCE_ATLAS_75650,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("hGpfM"))),
        owner: 'rrai2@atlassian.com',
        slackChannel: 'help-ipg',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/26ef3ad2-9433-4999-a2f6-fa985a8c97b6',
            'prod: https://pollinator.prod.atl-paas.net/checks/84735e69-d417-4319-ba90-edc743355d10'
        ]
    },
    {
        experience: (0, $6IwzG.AdvancedCobranding).JIRA_ATLAS_75650,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("hGpfM"))),
        owner: 'rrai2@atlassian.com',
        slackChannel: 'help-ipg',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/26ef3ad2-9433-4999-a2f6-fa985a8c97b6',
            'prod: https://pollinator.prod.atl-paas.net/checks/84735e69-d417-4319-ba90-edc743355d10'
        ]
    },
    {
        experience: (0, $6IwzG.AdvancedCobranding).ACCOUNT_LINKING,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("ciEgv"))),
        owner: 'vmanjunath@atlassian.com',
        slackChannel: 'help-community',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46'
        ]
    },
    {
        experience: (0, $6IwzG.AdvancedCobranding).ENTRY_AUTH,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("eooaG"))),
        owner: 'vmanjunath@atlassian.com',
        slackChannel: 'help-community',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46'
        ]
    },
    {
        experience: (0, $6IwzG.AdvancedCobranding).LOOM,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("2NhJc"))),
        owner: 'rbaldwin@atlassian.com',
        slackChannel: 'loom-team-identity',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/6309c2e3-d103-4f67-aeee-ba4c625602ea'
        ]
    },
    {
        experience: (0, $6IwzG.AdvancedCobranding).ISOLATED_CLOUD,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("exjs4"))),
        owner: 'fharrold@atlassian.com',
        slackChannel: 'id-kirby',
        monitoringUrls: [
            'TODO: https://hello.jira.atlassian.cloud/browse/IDOASIS-101'
        ]
    },
    {
        experience: (0, $6IwzG.AdvancedCobranding).TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("4Neo7"))),
        owner: 'tdermisek@atlassian.com',
        slackChannel: 'team-puma',
        monitoringUrls: [
            // https://hello.jira.atlassian.cloud/browse/PUMA-1559
            'TODO: PUMA-1559 Add pollinator check for TWCG-786 prioritise SSO login'
        ]
    }
];

});
parcelRegister("0xO0G", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("hvsjf")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bWK1p"))
]).then(()=>parcelRequire('62roJ'));

});

parcelRegister("jb1yl", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("gFWp2")).then(()=>parcelRequire('52wAX'));

});

parcelRegister("hGpfM", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bfA4J")).then(()=>parcelRequire('cMAk5'));

});

parcelRegister("ciEgv", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("8EdzW")).then(()=>parcelRequire('avf0M'));

});

parcelRegister("eooaG", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("4PNwD")).then(()=>parcelRequire('4XEP3'));

});

parcelRegister("2NhJc", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("9wcby")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("3N9O9"))
]).then(()=>parcelRequire('iZ71r'));

});

parcelRegister("exjs4", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("5Y3DV")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("1V5Wh"))
]).then(()=>parcelRequire('a1suH'));

});

parcelRegister("4Neo7", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("hG31Z")).then(()=>parcelRequire('kWJiU'));

});





//# sourceMappingURL=page.3a99630a.js.map
